module.exports = {"name":"ContentOptimization","parameters":[{"name":"enableAIGeneratedItems","value":false}]}